import React from 'react';
import styled from 'styled-components';

import NoResultsImageSrc from './NoResults.svg';

const NoResultsWrapper = styled.div`
  text-align: center;
  margin-top: 36px;
  margin-bottom: 0;
`;

const NoResultsImage = styled.img`
  width: 120px;
  margin: auto;
  text-align: center;
`;

export interface Props {
  body?: JSX.Element | string;
  title: JSX.Element | string;
}

const NoResults = ({ body, title }: Props) => {
  return (
    <NoResultsWrapper>
      <NoResultsImage src={NoResultsImageSrc} alt="" />
      <h3>{title}</h3>
      {body && <p>{body}</p>}
    </NoResultsWrapper>
  );
};

export default NoResults;
